import React from "react"
// react component for creating dynamic tables
import ReactTable, {ReactTableDefaults} from "react-table"
import {connect} from 'react-redux'
import moment from "moment-timezone";
import { CSVLink } from "react-csv"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
//import TextField from "@material-ui/core/TextField";
// @material-ui/icons
import Assessment from "@material-ui/icons/Assessment"

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import LinearProgress from '@material-ui/core/LinearProgress';

import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Datetime from "react-datetime";
import {sum} from 'lodash'

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"

import {
  tradingAccountsFetch,
  tradingAccountsCsv
} from 'actions/ibReports'
import {
  profileFilter,
  profilesAvailableFetch
} from 'actions/profiles'
import {
  ibTreeAvalableFetch
} from 'actions/ibTrees'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  datepickerLabel: {
    top: '-20px',
    left: '0',
    position: 'absolute',
    color: 'rgba(0, 0, 0, 0.26) !important',
    padding: '0',
    fontSize: '14px',
    fontWeight: '400',
    //textTransform: 'uppercase',
    lineHeight: '1'
  },
  datepickerText: {
    fontSize: '14px !important',
    paddingTop: '10px !important',
  },
  tableCell: {
    width: '120px',
  },
  cellRight: {
    textAlign: 'right'
  },
  line: {
    borderTop: '2px solid transparent',
    width: '90%',
    position: 'absolute',
    bottom: '-15px'
  }
};

class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
			from: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format(),
      to: moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format(),
      includeChildren: true,
      showIncludeChildren: true,
      profileId: 0,
      csv: ''
		}
  }
  csvLink = React.createRef()
	handleChange(e, filter){
    let state = this.state
    let value = filter === 'from' || filter === 'to' ? e : e.target.value
    if(filter === 'includeChildren'){
      value = !this.state.includeChildren
    }
    let includeChildren = this.state.includeChildren
    let showIncludeChildren = this.state.showIncludeChildren
    // showIncludeChildren
    this.props.ibTreeAvalableFetch({profileId: filter === 'profileId' ? value : state.profileId})
      .then((tree) => {
      if(tree.length <= 1) {

        includeChildren = false
        showIncludeChildren = false

      } else {

        includeChildren = true
        showIncludeChildren = true

      }
      state[filter] = value
      this.setState({...state});

      if (filter === 'profileId') {

        this.setState({
          ...state,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
        },() => this.fetchReport());
      
      }
    })
  }
  fetchReport(){
    const{from, to, includeChildren, profileId} = this.state
    
    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();

    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }

    if(profileId !== 0)
      params.profileId = profileId

    this.props.fetch(params)
  }
	componentDidMount(){
		this.props.profileFilter({size: 10000})
		this.props.profilesFetch().then((e) => {
      let fromDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(2,'day').format()
      let toDate = moment.tz(moment(new Date()).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format()
      let profile = e.content && e.content.length !== 0 ? e.content[0].profileId : 0
      let includeChildren = true
      let showIncludeChildren = true
      //if no sub ibs set includeChildren false
      if(profile !== 0){
        
        this.props.ibTreeAvalableFetch({profileId: profile}).then((tree) => {
          
          if(tree.length === 1) {
            includeChildren = false
            showIncludeChildren = false
          }
          this.setState({
            profileId: profile,
            includeChildren: includeChildren,
            showIncludeChildren: showIncludeChildren,
            from: fromDate,
            to: toDate
          },() => this.fetchReport())
        })
        
      }
      
    })
  }

  ValidDate( current ){
      let minDate = moment('2019-07-22 00:00:00');
      
      return current >= minDate;
  }

  exportCsv(){
    const{from, to, includeChildren, profileId} = this.state

    let fromFormat = moment.tz(moment(from).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').subtract(1,'day').format();
    let toFormat = moment.tz(moment(to).format('YYYY-MM-DD') + ' 5:00 PM', 'YYYY-MM-DD h:mm A', 'America/New_York').format();
    
    const params = {
      from: Date.parse(fromFormat),
      to: Date.parse(toFormat),
      includeChildren
    }
    if(profileId !== 0)
      params.profileId = profileId
    this.props.tradingAccountsCsv(params).then((e) => {
      this.setState({csv: e},() => this.csvLink.current.link.click())
    })
  }
	renderFilters(){
		const {classes, profiles} = this.props
    const {profileId} = this.state
    const fromDate = this.state.from
      ? moment(this.state.from).startOf('day').format('YYYY-MM-DD')
      : ''

    const toDate = this.state.to
      ? moment(this.state.to).endOf('day').format('YYYY-MM-DD')
      : ''

    // const tomorrow = moment.utc(new Date()).add(1,'days').endOf('day')
    // const valid = (current) => {
    //   return current.isBefore(tomorrow)
    // }
    
		return (
			<GridContainer style={{marginBottom: '30px'}}>
        <GridItem xs={2}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel htmlFor="profileId" className={classes.selectLabel} >
              Profile
            </InputLabel>
            <Select
              value={profileId}
              MenuProps={{
                className: classes.selectMenu
              }}
              classes={{
                select: classes.select
              }}
              inputProps={{
                onChange: (event) => this.handleChange(event, "profileId"),
                id: "profileId",
                name: "profileId"
              }}>
              {profiles
                .map((e) => (
                  <MenuItem
                    key={e.profileId}
                    classes={{
                      root: classes.selectMenuItem
                    }}
                    value={e.profileId}>
                    {e.profileId}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          
        </GridItem>
			
        <GridItem xs={3}>
            
            <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>Start Date *</InputLabel>
              <Datetime
                timeFormat={false}
                dateFormat={'YYYY-MM-DD'}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                utc={true}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                //isValidDate={valid}
                onChange={(event) => this.handleChange(event, "from")}
                value={fromDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
            </FormControl>
        </GridItem>

        <GridItem xs={3}>
          <FormControl className={classes.selectFormControl} style={{paddingTop: '5px'}} fullWidth>
              <InputLabel className={classes.datepickerLabel}>To Date *</InputLabel>
              <Datetime
                timeFormat={false}
                utc={true}
                //isValidDate={valid}
                dateFormat={'YYYY-MM-DD'}
                isValidDate={ this.ValidDate }
                locale={moment.locale('en',{week: {
                  dow: 1
                }})}
                inputProps={{placeholder: 'yyyy/mm/dd'}}
                onChange={(event) => this.handleChange(event, "to")}
                value={toDate}
                className={classes.select + ' ' + classes.datepickerText}
              />
          </FormControl>
        </GridItem>
        {this.state.showIncludeChildren && (
          <GridItem xs={2}>
            <FormControlLabel
              style={{marginTop:'15px'}}
              control={
                <Checkbox
                  color="default"
                  checked={this.state.includeChildren}
                  onChange={(event) => this.handleChange(event, "includeChildren")}
                />
              }
              classes={{
                label: classes.linkFooter
              }}
              label="Including SubIBs"
            />
          </GridItem>
        )}
        <GridItem xs={2}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.fetchReport()} className={classes.submit} color="success">Search</Button>
          </div>
        </GridItem>
        
				
			</GridContainer>
		)
  }
  setPageSizeOptions(data){
    const pageSizeOptions = [10]
    if(data.length > 10) {
      pageSizeOptions.push(20)
    }
    if(data.length > 20) {
      pageSizeOptions.push(50)
    }
    if(data.length > 50) {
      pageSizeOptions.push(100)
    }

    Object.assign(ReactTableDefaults, {
      pageSizeOptions: pageSizeOptions,
    })
    return pageSizeOptions
  }
  render() {
    const { classes, report:{data},reports } = this.props
    this.setPageSizeOptions(data)
    
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assessment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>My Reports</h4>
            </CardHeader>
            <CardBody>
							{this.renderFilters()}
							{(reports.isFetching) ?
              (<LinearProgress color="primary"/>)
              :
              (<div>
              <ReactTable
                data={data}
                // onPageSizeChange={(pageSize, pageIndex) => {
                //   console.log(pageSize)
                // }}
                columns={[
                  {
                    id: '1',
                    sortable: true,
                    Header: () => <div><span>{'Trading Account Number'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[1]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '3',
                    sortable: true,
                    Header: () => <div><span>{'Platform'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[3]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '5',
                    sortable: true,
                    Header: () => <div><span>{'Currency'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[5]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '7',
                    sortable: true,
                    Header: () => <div><span>{'Client Name'}</span><hr className={classes.line} /></div>,
                    width: 160,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[7]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '9',
                    sortable: true,
                    Header: () => <div><span>{'IB Name'}</span><hr className={classes.line} /></div>,
                    width: 250,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[9]
                    ,
                    Footer: (
                      <span></span>
                    )
                  },
                  {
                    id: '11',
                    sortable: true,
                    Header: () => <div><span>{'Profile Name'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    headerClassName: 'customHeader',
                    accessor: d => d[11]
                    ,
                    Footer: (
                      <span><strong>Total (USD)</strong></span>
                    )
                  },
                  
                  {
                    id: '12',
                    Header: () => <div className={classes.tableCell}><span>{'Volume (USD)'}</span><hr className={classes.line} /></div>,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    width: 120,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[12] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[12]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '13',
                    Header: () => <div className={classes.tableCell}><span>{'Markup Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[13] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[13]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  
                  {
                    id: '14',
                    Header: () => <div className={classes.tableCell}><span  style={{width: '95px'}}>{'Commission Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[14] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[14]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '15',
                    Header: () => <div className={classes.tableCell}><span>{'Spread Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[15] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[15]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  },
                  {
                    id: '16',
                    Header: () => <div className={classes.tableCell}><span style={{width: '87px'}}>{'Rebate on Shares (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => Math.round(d[16] * 100) / 100,
                    Footer: (
                      data.length !== 0 ? <span>{Math.round(sum(data.map((row) => Number(row[16]))) * 100) / 100}</span> : ''
                    )
                  },
                  {
                    id: '17',
                    Header: () => <div className={classes.tableCell}><span>{'Total Rebate (USD)'}</span><hr className={classes.line} /></div>,
                    width: 120,
                    headerStyle: {
                      whiteSpace: 'unset'
                    },
                    //className: classes.cellRight,
                    headerClassName: 'customHeader',
                    accessor: d => (Math.round(d[17] * 100) / 100).toLocaleString(),
                    Footer: (
                      data.length !== 0 ? <span>{(Math.round(sum(data.map((row) => Number(row[17]))) * 100) / 100).toLocaleString()}</span> : ''
                    )
                  }
                ]}
                defaultPageSize={10}
                // showPaginationTop
                // showPaginationBottom={false}
                className="-striped -highlight"
              />
              
              <div style={{float:'left', marginTop: '20px', width:'100%'}}>
                <span>* Trading day starts at 5pm New York timezone.</span>
              </div>
              </div>
              )}
              
            </CardBody>
          </Card>
        </GridItem>
        {<GridItem xs={12}>
          <div style={{float:'right'}}>
            <Button onClick={() => this.exportCsv()} className={classes.submit} color="success">Export CSV</Button>
            <CSVLink data={this.state.csv} filename={"accounts-total-rebates.csv"} ref={this.csvLink} className="hidden" />
          </div>
        </GridItem>}
      </GridContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  report: state.ibReports.tradingAccounts,
	reports: state.ibReports,
	profiles: state.profiles.list
})

const mapDispatchToProps = (dispatch) => ({
  fetch: (params) => dispatch(tradingAccountsFetch(params)),
  tradingAccountsCsv: (params) => dispatch(tradingAccountsCsv(params)),
  profilesFetch: () => dispatch(profilesAvailableFetch()),
  profileFilter: (filter) => dispatch(profileFilter(filter)),
  ibTreeAvalableFetch: (data) => dispatch(ibTreeAvalableFetch(data))
})

export default withStyles({...styles, ...selectStyles, ...extendedFormsStyle})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/TradingAccountsReport/List.jsx